// extracted by mini-css-extract-plugin
export default {"root":"TimeRange_root__dRf5u","bookingInfo":"TimeRange_bookingInfo__QULa1","dateSection":"TimeRange_dateSection__0w5E0"};